import { SVGProps } from 'react';

export const RightArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.8086 5.21484L10.0898 8.93359C9.81641 9.20703 9.40625 9.20703 9.16016 8.93359C8.88672 8.6875 8.88672 8.27734 9.16016 8.00391L11.7578 5.40625H0.65625C0.273438 5.40625 0 5.13281 0 4.75C0 4.39453 0.273438 4.09375 0.65625 4.09375H11.7578L9.16016 1.49609C8.88672 1.25 8.88672 0.839844 9.16016 0.566406C9.40625 0.320312 9.81641 0.320312 10.0898 0.566406L13.8086 4.3125C14.0547 4.55859 14.0547 4.96875 13.8086 5.21484Z"
      fill="#2B2B2B"
    />
  </svg>
);
